// extracted by mini-css-extract-plugin
export default {"contentVisible":"kMTRyXpe","draggable":"zb_qWcwn","item":"pf7h1vsu","draggableItem":"zQvPYRv2","verticalMenu":"vVu4xhwI","menuIcon":"t30fomR3"};